// Shows real album art when a URL is available; otherwise a branded placeholder instead of an
// empty box. Once musicbrainz enrichment (or a manual edit) sets album_art_url, callers just
// pass the new url and this swaps over automatically — no separate "loaded" state to manage.
export default function AlbumArt({ url, size = "lg", className = "", loading }) {
  if (url) {
    return <img src={url} alt="" loading={loading} className={`w-full h-full object-cover ${className}`} />;
  }
  const small = size === "sm";
  return (
    <div className={`w-full h-full flex items-center justify-center bg-gradient-to-br from-[#161616] to-[#0a0a0a] ${className}`}>
      {small ? (
        <span className="font-display font-black text-[#3a3a3a] text-lg select-none">S<span className="text-[#D9381E]">.</span></span>
      ) : (
        <span className="font-display font-black tracking-tighter text-[#3a3a3a] text-sm sm:text-base select-none text-center px-2">
          Stream<span className="text-[#D9381E]">hoard</span>
        </span>
      )}
    </div>
  );
}
